import React from 'react';

const getChartColorToken = (color) => (color || "").replace("#", "").toLowerCase();

/**
 * Interactive Legend Component for Recharts
 * Allows clicking legend items to hide/show chart series
 * Legend items remain visible with strikethrough when hidden
 * Fixed height container for consistent chart sizing
 * 
 * @param {Object} payload - Legend payload from Recharts
 * @param {Object} hiddenSeries - Object mapping dataKey to boolean (hidden state)
 * @param {Function} onToggleSeries - Callback function when legend item is clicked
 */
export const InteractiveLegend = ({ payload, hiddenSeries, onToggleSeries }) => {
    if (!payload || !payload.length) return null;

    return (
        <div className="oct_interactive-legend-v2">
            {payload.map((entry, index) => {
                // Check if this series is hidden using either dataKey or value (name)
                const itemKey = entry.dataKey || entry.value;
                const isHidden = hiddenSeries[itemKey];

                return (
                    <div
                        key={`legend-${index}`}
                        className={`legend-item ${isHidden ? 'hidden' : ''}`}
                        onClick={() => onToggleSeries(itemKey)}
                    >
                        <div
                            className="legend-color-box"
                            data-chart-color={getChartColorToken(entry.color)}
                        />
                        <span className="legend-text">
                            {entry.value}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};
